import React from "react";
import { Eye, Target, Sparkles } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function ValuesGrid() {
  const { t } = useLanguage();
  const values = [
    { icon: Eye, k: "about.values.transparency" },
    { icon: Target, k: "about.values.performance" },
    { icon: Sparkles, k: "about.values.creativity" },
  ];

  return (
    <section data-testid="about-values-section" className="bg-cream py-section sm:py-section-lg border-t border-mist">
      <div className="container-page">
        <Reveal as="div" className="max-w-2xl">
          <span className="eyebrow"><Sparkles className="h-3 w-3 text-gold" />{t("about.values_eyebrow")}</span>
          <h2 className="mt-5 font-display text-display-2 font-semibold text-ink">
            {t("about.values_title_pre")}{" "}
            <span className="gold-foil-text">{t("about.values_title_accent")}</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 lg:grid-cols-3">
          {values.map((v, i) => {
            const Icon = v.icon;
            return (
              <Reveal as="div" key={v.k} delay={i * 0.08}
                className="rounded-2xl border border-mist bg-white p-7 sm:p-8 hover:border-gold/40 transition-colors duration-500"
                data-testid={`value-card-${i + 1}`}
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold">
                  <Icon className="h-5 w-5" strokeWidth={1.5} />
                </span>
                <h3 className="mt-6 font-display text-h2 font-semibold text-ink">{t(`${v.k}.title`)}</h3>
                <p className="mt-3 text-sm text-ink/65 leading-relaxed">{t(`${v.k}.desc`)}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
